// VendorBanner.js — drop this above your "X Vendor(s) Found" line
// in your marketplace/vendor listing component

import React from "react";

const VendorBanner = () => (
  <div style={{
    background: "linear-gradient(135deg, #1A2280 0%, #2A3390 100%)",
    borderRadius: "10px",
    padding: "20px 24px",
    marginBottom: "20px",
    borderLeft: "5px solid #D4921A",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "16px",
  }}>
    {/* Left: icon + text */}
    <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", flex: 1, minWidth: "280px" }}>
      {/* House icon */}
      <div style={{
        width: "44px", height: "44px", minWidth: "44px",
        background: "rgba(212,146,26,0.2)",
        border: "1.5px solid rgba(212,146,26,0.4)",
        borderRadius: "10px",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "22px", flexShrink: 0,
      }}>
        🏠
      </div>

      <div>
        {/* Eyebrow */}
        <div style={{
          fontSize: "10px", fontWeight: "700", color: "#D4921A",
          textTransform: "uppercase", letterSpacing: "1.2px",
          marginBottom: "4px", fontFamily: "DM Sans, sans-serif",
        }}>
          For Contractors, Vendors &amp; Service Providers
        </div>

        {/* Headline */}
        <div style={{
          fontSize: "18px", fontWeight: "700", color: "white",
          fontFamily: "Georgia, serif", marginBottom: "4px", lineHeight: "1.3",
        }}>
          Stop chasing leads.{" "}
          <span style={{ color: "#D4921A", fontStyle: "italic" }}>Start receiving them.</span>
        </div>

        {/* Sub text */}
        <div style={{
          fontSize: "12px", color: "rgba(255,255,255,0.72)",
          fontFamily: "DM Sans, sans-serif", lineHeight: "1.5", marginBottom: "10px",
        }}>
          We visit the home, earn the trust, and refer you directly to homeowners with a confirmed need — no cold calling, no tire-kickers.
        </div>

        {/* Benefit pills */}
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {[
            { label: "✓  Pre-qualified leads", gold: true },
            { label: "✓  No upfront fees" },
            { label: "✓  Built-in homeowner trust" },
          ].map((pill, i) => (
            <span key={i} style={{
              padding: "4px 12px",
              borderRadius: "12px",
              fontSize: "10px", fontWeight: "600",
              fontFamily: "DM Sans, sans-serif",
              background: pill.gold ? "rgba(212,146,26,0.18)" : "rgba(255,255,255,0.08)",
              border: `1px solid ${pill.gold ? "#D4921A" : "rgba(255,255,255,0.2)"}`,
              color: pill.gold ? "#D4921A" : "rgba(255,255,255,0.82)",
            }}>
              {pill.label}
            </span>
          ))}
        </div>
      </div>
    </div>

    {/* Right: CTA button */}
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", flexShrink: 0 }}>
      <a
        href="https://go.myhomebuddha.com/vendors"
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-block",
          padding: "12px 28px",
          background: "#D4921A",
          color: "#2A1600",
          borderRadius: "50px",
          fontFamily: "DM Sans, sans-serif",
          fontSize: "13px",
          fontWeight: "800",
          textDecoration: "none",
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        Become a Provider →
      </a>
      <span style={{
        fontSize: "10px", color: "rgba(255,255,255,0.4)",
        fontFamily: "DM Sans, sans-serif",
      }}>
        Plans from $0 · $50 · $100/mo
      </span>
    </div>
  </div>
);

export default VendorBanner;

// ─── USAGE ───────────────────────────────────────────────────────────────────
// In your marketplace/vendor listing component, import and place above results:
//
//   import VendorBanner from "./VendorBanner";
//
//   <VendorBanner />
//   <div>2 Vendor(s) Found</div>
//   ... vendor cards ...